const vendors = ['webkit', 'moz', 'ms', 'o'];
const elementStyle = document.createElement('div').style;

/* eslint-disable no-undef */
export const support3d = 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix();
/* eslint-enable no-undef */

/**
 * @description get css prefix
 * @param {string} style style
 * @returns {string} style
 */
export const vendorPrefix = (style: string) => {
    if (!style) {
        return style;
    }
    const capitalStyle = style.charAt(0).toUpperCase() + style.substr(1);
    for (let i = 0, j = vendors.length; i < j; i++) {
        const prefixStyle = vendors[i] + capitalStyle;
        if (prefixStyle in elementStyle) {
            return `-${vendors[i]}-${style}`;
        }
    }

    return style;
};
